import { Currency } from "../../types/Currency/Currency";
import CurrencyConstants from "../constants/currencyConstants";

const initialState: { currencies: Currency[] } = {
  currencies: [],
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case CurrencyConstants.GET_CURRENCIES_LIST_SUCCESS:
      return {
        ...state,
        currencies: action.payload.data.results,
      };
    default:
      return {
        ...state,
      };
  }
};
